<template>
  <div class="header-login wf-section">
    <div class="container-header-login w-container">
      <div class="w-layout-grid grid-header-login">
        <div id="w-node-_03ddceca-a534-b55e-e4cc-69b8261c6240-261c623d" class="zone-logo">
          <a href="https://pautions.fr" target="_blank"><img :src="require('@/assets/images/logo_pautions.svg')" loading="lazy" width="120" alt="" /></a>
        </div>
        <div id="w-node-_584d43b4-e90f-3956-cfd0-aa02149a422e-261c623d" class="zone-call">
          <a href="tel:+33970386826" class="link-block w-inline-block"><img :src="require('@/assets/images/ic_tel.svg')" loading="lazy" width="20" alt="" /></a>
          <p id="w-node-_03ddceca-a534-b55e-e4cc-69b8261c6243-261c623d" class="paragraph info">Besoin d’aide pour vous connecter ? Appelez notre service client au 09 70 38 68 26.</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "",
  data: () => ({

  }),
  computed:{
  },
  mounted() {
    //this.$store.api.initMenuMobile();
  }
}
</script>
<style lang="scss" scoped>
</style>
